// Helpers do checklist de materiais (motorista). O valor trafega como JSON
// string; aqui parseamos com tolerância (string, objeto, vazio) e resumimos
// para exibição na tabela de Cadastros.

export interface ChecklistItem {
  ok: boolean;
  qtd: number;
}
export type ChecklistState = Record<string, ChecklistItem>;

export function parseChecklist(value: unknown): ChecklistState {
  if (value == null || value === "") return {};
  let obj: unknown = value;
  if (typeof value === "string") {
    try { obj = JSON.parse(value); } catch { return {}; }
  }
  if (!obj || typeof obj !== "object") return {};
  const out: ChecklistState = {};
  for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
    if (v && typeof v === "object") {
      const o = v as Record<string, unknown>;
      out[k] = { ok: !!o.ok, qtd: Number(o.qtd) || 0 };
    } else if (typeof v === "number") {
      out[k] = { ok: v > 0, qtd: v }; // tolera formato { item: qtd }
    } else if (typeof v === "boolean") {
      out[k] = { ok: v, qtd: v ? 1 : 0 };
    }
  }
  return out;
}

// Resumo curto p/ a coluna da tabela: "Cinta 6 · Catraca 4" (só itens presentes).
export function summarizeChecklist(value: unknown): string {
  const state = parseChecklist(value);
  const parts = Object.entries(state)
    .filter(([, s]) => s.ok || s.qtd > 0)
    .map(([item, s]) => (s.qtd ? `${item} ${s.qtd}` : item));
  return parts.length ? parts.join(" · ") : "—";
}
